import { render } from "./GameDetails.vue?vue&type=template&id=6e6ae1f6&scoped=true"
import script from "./GameDetails.vue?vue&type=script&lang=js"
export * from "./GameDetails.vue?vue&type=script&lang=js"

import "./GameDetails.vue?vue&type=style&index=0&id=6e6ae1f6&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\diloti\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e6ae1f6"]])

export default __exports__